import { render } from "./referenceVue.vue?vue&type=template&id=55bf25bd&lang=true"
import script from "./referenceVue.vue?vue&type=script&lang=js"
export * from "./referenceVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__